import { render, staticRenderFns } from "./MtsTakipAcIslemDetayView.vue?vue&type=template&id=f4fd89c0&scoped=true"
import script from "./MtsTakipAcIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./MtsTakipAcIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fd89c0",
  null
  
)

export default component.exports